template = require('./menu_mobile_secondary.html.slim')
controller = require('./menu_mobile_secondary_controller')

angular.module('wbComponents').directive 'wbMenuMobileSecondary', ->
  restrict: 'E'
  replace: true
  bindToController: true
  controllerAs: 'ctrl'
  templateUrl: template
  controller: controller
  scope:
    steps: '='
    currentStep: '='
    toggle: '='

  link: ($scope, $el, $attrs) ->
